interface GuestCatalogSectionCardProps {
  children: React.ReactNode;
}

export function GuestCatalogSectionCard({ children }: GuestCatalogSectionCardProps) {
  return <div className="rounded-xl border border-gray-200/80 bg-white p-4 sm:p-6">{children}</div>;
}
